import React from 'react';
import Hdr from '../shared/Hdr';

import { useState, useEffect } from 'react';
import swal from 'sweetalert';

import { apiPath1 } from "../services/apiConfig";
import TopBanner from '../components/TopBanner';

function Reports() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const usrName = localStorage.getItem('userName');

  const [categoryData, setCategoryData] = useState([])
  const [tools, setTools] = useState([])
  const [categoryId, setCategoryId] = useState()
  const [historyStatus, setHistoryStatus] = useState([])
  const [history, setHistory] = useState([])
  const [toolCode, setToolCode] = useState()
  const [toolName, setToolName] = useState()

  const [zeroStock, setZeroStock] = useState([])
  const [zeroStockStat, setZeroStockStat] = useState()

  const [selectCategoryValue, setSelectCategoryValue] = useState('0')

  useEffect(() => {
  //  getToolCategory()
  //  getZeroStockIndent()
  }, [])

  /* LIST OF ALL TOOL CATAGORY List */
/*
  async function getToolCategory() {

    let result = await fetch(apiPath1 + "HeavyToolsCategory",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setCategoryData(result.data) }
    else { setCategoryData([]) }
  }
*/
  /* LIST OF ALL TOOLS CATAGORYWISE */
  /*
  async function getTools(id) {

    // alert(id)

    let result = await fetch(apiPath1 + "ToolCategoryWise/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setTools(result.data) }
    else { setTools([]) }
  }
*/
/*
  async function getHistory() {

    // alert(toolCode)

    let result = await fetch(apiPath1 + "HeavyToolMovementHistory/" + toolCode,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    //  alert(result.status)

    setHistoryStatus(result.status)

    if (result.status === true) {
      setHistory(result.data)
      setToolName(result.data[0].ToolName)
    }

    else { setHistory([]) }
  }
*/

  async function getZeroStockIndent() {

    // alert(toolCode)

    let result = await fetch(apiPath1 + "PendingIndentItemsNotInInventory",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();



 //   setHistoryStatus(result.status)

    setZeroStockStat(result.status)

    if (result.status === true) {
      setZeroStock(result.data)
      console.log(result.data)
   //   setToolName(result.data[0].ToolName)
    }

    else { setZeroStock([]) }
  }



  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  /*
  function categoryHandler(e) {

    if (e.target.value === '0') {
      setTools([])
      setHistoryStatus(false)
      setHistory([])
    }

    e.preventDefault()
    setSelectCategoryValue(e.target.value)
    setCategoryId(e.target.value)
    getTools(e.target.value)
  }

  function toolHandler(e) {
    setToolCode(e.target.value)
  }
    */

  /*
  function typeToName(type) {

    switch (type) {
      case 'I':
        return ('Issued')
      case "D":
        return ("Indented")
      case "R":
        return ("Received")
      case 'T':
        return ("Transferred")
      case 'N':
        return ("Returned")
      case 'P':
        return ("Purchased")
      case 'X':
        return ("Send for Repair")
      case 'O':
        return ("Opening Entry")
      case 'Y':
        return ("Repaired & Returned")
      default:
        return (type)
    }

    return (type)
  }
*/

function reportHandler(e){
  getZeroStockIndent()
}

  return (

    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Reports'} />

      <div className="row p16" style={{ 'height': '100%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>
          {/* SEARCH OPTION SECTION */}
          <div className="row mb16 pb16" style={{ 'border-bottom': '1px solid #B9B9B9' }}>

          <div className="c12-l-6">
            <p className='txt-darkblue'>Select Report</p>
            <select className="small" onChange={reportHandler} style={{ "width": '98%' }} >
              <option value="">Select Report</option>
              <option value="1">Requisition Requirement for Pending Indent Items</option>
          </select>
        </div>


          {/*
            <div className="c12-l-3">
              <p className='txt-darkblue' >Select Tool Category</p>
              <select className="small" value={selectCategoryValue} onChange={categoryHandler} style={{ "width": '98%' }} >
                <option value="0" >Open List</option>
                {
                  categoryData.map((item, index) =>
                    <option key={item.id} value={item.id}>{item.category_name}</option>
                  )
                }
              </select>
            </div>
*/}
{/*
            <div className="c12-l-3">
              <p className='txt-darkblue' >Select A Heavy Tool</p>
              <select className="small" onChange={toolHandler} style={{ "width": '98%' }} >
                <option value="0" >Open List</option>
                {
                  tools.map((item, index) =>
                    <option key={item.id} value={item.tool_code}>{item.tool_name}</option>
                  )
                }
              </select>
            </div>
        */}
{/*
            <div className="c12-l-3 align-bottom-right">
              <button onClick={getHistory} type="button" name="button"
                className="btn gradient round xl">Show Movement History</button>
            </div>
*/}
          </div>

          {/* HEADING SECTION */}
          {/*
          <div className="">
            {
              (historyStatus === true ? <h5 className=' center wide'>Movement History of Tool : {toolCode} - {toolName}</h5> : <h5 className=' center wide'>Movement History of Tool</h5>)
            }
          </div>
*/}
          {/* DATA TABLE SECTION */}
          <div className="c12-l-12 cont__content p4 mt8" style={{ 'height': '75%' }}>
            <table className='table-border-grey mx-auto'>
              <thead className='thead-blue'>
                <th className="th-border left color-reverse" width="25%">Indent from Store</th>
                <th className="th-border left color-reverse" width="15%">Indent Number</th>
               
                <th className="th-border left color-reverse" width="30%">Tool Name</th>
                <th className="th-border left color-reverse" width="10%">Quantity Required</th>
                <th className="th-border left color-reverse" width="35%">Despatch Store</th>
                <th className="th-border left color-reverse" width="25%">Available Qty</th>
              </thead>
              <tbody >
                {
                  (zeroStockStat === true ?
                    (
                        zeroStock.map((item, index) =>
                        <tr className="tr-two-color-grey" key={index}>

                          <td className="">{item.indent_from_store}</td>
                          <td className="">{item.indent_number}</td>
                         
                          <td className="">{item.tool_name}</td>
                          <td className="">{item.qty_reqd}</td>
                          <td className="">{item.despatch_store}</td>
                          <td className="">{item.available_qty}</td>

                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>





        </div>
      </div>


    </div>
  );
}

export default Reports;